import { IForm } from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'liveStatus',
      type: 'select',
      label: '直播状态',
      clearable: true,
      placeholder: '请选择直播状态',
      options: [
        {title: '直播中', value: '直播中'},
        {title: '已结束', value: '已结束'},
      ]
    },
    // {
    //   field: 'liveStatus',
    //   type: 'select',
    //   label: '平台',
    //   clearable: true,
    //   placeholder: '请选择平台',
    //   options: [
    //     {title: '全部', value: '0'},
    //     {title: '视频号', value: '1'},
    //   ]
    // },
    {
      field: 'accountName',
      type: 'input',
      label: '搜索直播间',
      placeholder: '输入直播间名称或ID'
    },
    {
      field: 'thirdParty',
      type: 'select',
      label: '三方',
      filterable: true,
      clearable: true,
      placeholder: '请选择三方'
    },
    {
      field: 'dataTime',
      type: 'datepicker',
      label: '查询日期',
      clearable: true,
      otherOptions: {
        placeholder: '选择日期',
        type: 'date',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          return new Date() < date
        }
      }
    }
  ]
}
